const ENMapsObjective = {
	"Adicionar Indicador": "Add Indicator",
	"Adicionar Objetivo": "Add Objective",
	"Alterar Objetivo": "Change Objective",
	"Calcular percentual por": "Calculate percentage by",
	"Deseja realmente excluir o objetivo": "Do you really want to delete the objctive",
	"Editar Objetivo": "Change Objective",
	"Erro ao adicionar objetivo": "Error adding objective",
	"Erro ao alterar objetivo": "Error updating objctive",
	"Erro ao buscar objetivos": "Error in seeking goals",
	"Erro ao excluir objetivo": "Error deleting objective",
	"Excluir Objetivo": "Delete Objective",
	"Exclusão de Objetivo": "Deleting the Objective",
	"Indicador é requerido": "Indicator is required",
	"Indicadores e Ações": "Indicators and Actions",
	"Indicadores e Projetos": "Indicators and Projects",
	"Indicadores, Projetos e Ações": "Indicators, Projects and Actions",
	"Ir ao projeto": "Go to project",
	"Listar Iniciativas": "List Iniciatives", 
	"Mover Objetivo": "Move Objective",
	"Nenhum objetivo encontrado": "No goals found",
	"Novo Objetivo": "New Objective",
	"Objetivo adicionad com sucesso": "Objective successfully added",
	"Objetivo alterado com sucesso": "Objective successfully changed",
	"Objetivo excluído com sucesso": "Objective successfully deleted",
	"Projetos e Ações": "Projects and Actions",
	"Perspectiva": "Perspective",
	"Relacionar Causa/Efeito": "Relate Cause/Effect"
};

export default ENMapsObjective;
